<template>
  <div class="dict">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ this.$t('salePurchase.add.info') }}
          </div>
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <costInfo
            ref="costInfo"
            v-bind:baseData="baseData"
            :canEdit="canEdit"
            :companyList="companyList"
            @updateForm="updateForm"
          ></costInfo>
        </div>
      </el-collapse-item>
      <div class="m-b">
        <el-tabs type="card" v-model="activeNameTab" class="common-tab">
          <el-tab-pane label="行信息" name="first">
            <div class="main-content" style="padding-bottom: 20px">
              <detailData
                :detailDataList="detailDataList"
                :canEdit="canEdit"
                ref="detailData"
              ></detailData>
            </div>
          </el-tab-pane>
          <el-tab-pane name="voucherTab" :label="$t('addInvoice.invoiceLine.title2')">
            <voucher
              ref="voucher"
              :voucherList="voucherList"
              @reverseInfo="reverseInfo"
              @postInfo="postInfo"
              @doConfirmInfo="doConfirmInfo"
            ></voucher>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!--编辑 -->
      <el-button
        :disabled="
          (['Saved', 'Rejected'].indexOf(baseData.docStatus) == -1 && !canEdit) ||
          !baseData.docStatus
        "
        type="primary"
        @click="edit"
        v-hasPermi="['2021050814190881587']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.edit') }}
      </el-button>
      <!-- 保存 -->
      <el-button
        :disabled="['', 'Saved', 'Rejected'].indexOf(baseData.docStatus) == -1 || !canEdit"
        type="primary"
        @click="save"
        v-hasPermi="['2021050814192075562']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.save') }}</el-button
      >
      <!-- 提交 -->
      <el-button
        :disabled="['Saved', 'Rejected'].indexOf(baseData.docStatus) == -1"
        type="primary"
        @click="submit"
        v-hasPermi="['2021050814193147166']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.submit') }}</el-button
      >
      <!-- 确认 -->
      <el-button
        :disabled="['Submitted'].indexOf(baseData.docStatus) == -1"
        type="primary"
        @click="doConfirm"
        v-hasPermi="['2021050814195492992']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.confirm') }}</el-button
      >
      <!-- 生成凭证 只有已确认状态才能点击生成凭证按钮。-->
      <el-button
        :disabled="
          ['Confirmed'].indexOf(baseData.docStatus) == -1 ||
          ['notgenerate', 'generated', 'postError'].indexOf(baseData.accountingStatus) == -1
        "
        type="primary"
        @click="handleAccountEntry"
        v-hasPermi="['2021050814200559568']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.generateCredentials') }}</el-button
      >
      <!-- 过账凭证 只有已确认状态才能点击生成凭证按钮。-->
      <el-button
        :disabled="
          ['Confirmed'].indexOf(baseData.docStatus) == -1 ||
          ['generated', 'postError'].indexOf(baseData.accountingStatus) == -1
        "
        type="primary"
        @click="doSyncVoucherForEntityData()"
        v-hasPermi="['2021050814201565920']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('functionBtn.doSyncVoucher') }}</el-button
      >
      <!-- 撤回 只有单据状态为“已提交”的单据才能点击该按钮-->
      <el-button
        :disabled="['Submitted'].indexOf(baseData.docStatus) == -1"
        type="primary"
        @click="doWithdraw"
        v-hasPermi="['2021050814204659576']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.doWithdraw') }}</el-button
      >
      <!-- 冲销 单据状态为：已确认的单据才能点击冲销按钮。-->
      <el-button
        :disabled="['Confirmed'].indexOf(baseData.docStatus) == -1"
        type="primary"
        @click="doReverseAccountEntry()"
        v-hasPermi="['2021050814205678181']"
        :loading="load"
        class="fixed-bottom-btn"
        >{{ this.$t('costAdjustOrderList.btns.writeOff') }}</el-button
      >
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  // import { filterEmpty } from '@/common/js/util';
  import API from '@/api/wareHouse/costAdjustOrder';
  import costInfo from './components/costInfo';
  import detailData from './components/inboundList';
  // import financeForm from './components/financeForm';
  import DataBaseAPI from '@/api/dataBase';
  import loading from '@/common/js/load.js'; //loading
  import voucherMixins from '@/common/mixins/voucher.js';
  import XEUtils from 'xe-utils';
  export default {
    components: {
      costInfo,
      detailData,
      // financeForm, //会计凭证
    },
    name: 'costAdjustOrderAdd',
    mixins: [voucherMixins],
    data() {
      // const date = XEUtils.toDateString(new Date(), 'yyyy-MM-dd');
      return {
        voucherFlag: 'AE_PO_COSTADJUST', //凭证标识
        activeNameTab: 'first',
        load: false,
        flag: this.$route.query.flag,
        activeNames: ['1', '2'],
        baseData: {}, //form表单数据
        detailDataList: [], //行信息
        companyList: [], //公司列表
        departmentList: [], // 部门列表
        dialogVisible: false,
        canEdit: this.$route.query.isEdit == 'Y',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {
      this.getCompany();
      if (this.$route.query.query) {
        this.query = JSON.parse(this.$route.query.query);
        this.baseData = JSON.parse(JSON.stringify(this.baseData));
      }
      let data = {};
      if (this.$route.query.costAdjustList) {
        //新增库存成本调整单
        this.baseData = this.$route.query.costAdjustList; // form
        data = this.filterEmpty(this.baseData);
        XEUtils.lastObjectEach(data, (item, key) => {
          this.$refs.costInfo.formData[key] = item;
        });
        this.$refs['costInfo'].getdepartmentList(this.baseData.storageCompanyCode);
        this.detailDataList = this.$route.query.costAdjustList.detailList;
      } else if (this.$route.query.id) {
        //查看详情
        this.getDetail(this.$route.query.id);
      }
    },
    methods: {
      // 获取详情信息
      getDetail(id = this.baseData['id']) {
        loading.startLoading();
        this.$axios
          .get(`${API.COST_ADJUST_QUERYBYID}/${id}`)
          .then((res) => {
            loading.endLoading();
            if (0 == res.data.code) {
              // 获取凭证ID 获取凭证列表
              this.entityDataId = id;
              this.getAccountEntry();
              this.baseData = res.data.data;
              let formData = this.filterEmpty(this.baseData);
              XEUtils.lastObjectEach(formData, (item, key) => {
                this.$refs.costInfo.formData[key] = item;
              });
              this.detailDataList = res.data.data.detailList;
              this.$refs['costInfo'].getdepartmentList(this.baseData.storageCompanyCode);
            } else {
              this.$alert(res.data.msg);
            }
          })
          .catch(() => loading.endLoading());
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      //更新表单信息
      updateForm(baseData) {
        this.baseData = { ...this.baseData, ...baseData };
      },
      // 校验表单
      validate() {
        return new Promise((resolve) => {
          this.$refs.costInfo.$refs.formData.handleSubmit().then(() => {
            resolve(true);
          });
        });
      },
      // 编辑
      edit() {
        this.canEdit = true;
      },
      //保存
      async save() {
        this.detailDataList =
          this.$refs['detailData'].$refs['detailDataList'].getTableData().fullData;
        if (this.detailDataList.length == 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '请添加行信息',
          });
          return;
        }
        let baseData = {
          ...this.baseData,
          detailList: this.detailDataList,
        };
        baseData = this.$baseRequest.assignObj(baseData);
        this.saveData(baseData);
      },
      async saveData(baseData) {
        loading.startLoading();
        let res = await this.$axios.post(API.COST_ADJUST_SAVE, baseData);
        if (res) {
          loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.saveSussess'),
            });
            this.getDetail(res.data.data.id);
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        } else {
          loading.endLoading();
        }
      },
      //提交
      async submit() {
        let flag = await this.validate(); //校验表单
        if (!flag) return;
        this.detailDataList =
          this.$refs['detailData'].$refs['detailDataList'].getTableData().fullData;
        let submitFlag = true;
        this.detailDataList.map((item) => {
          if (item.adjustStorageAmount == 0) {
            submitFlag = false;
            this.$message({
              showClose: true,
              type: 'error',
              message: '行号为' + item.sortNo + '的业务库存调整金额不能为零',
            });
          }
        });
        if (!submitFlag) return;
        let baseData = {
          ...this.baseData,
          detailList: this.detailDataList,
        };
        baseData = this.$baseRequest.assignObj(baseData);
        this.$axios
          .post(API.COST_ADJUST_SUBMIT_APPROVAL, baseData)
          .then((res) => {
            loading.endLoading();
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '提交成功',
                type: 'success',
              });
              this.goBack();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => loading.endLoading());
      },
      async delet() {
        this.baseData = { docNo: this.baseData.docNo };
        this.$confirmAction().then(() => {
          this.$axios.post(API.COST_ADJUST_DELETE, this.baseData).then((res) => {
            if (0 == res.data.code) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.goBack();
            } else {
              this.$alert(res.data.msg);
            }
          });
        });
      },
      // 确认
      doConfirmInfo(info) {
        const baseData = {
          id: this.baseData.id,
          ...info,
        };
        loading.startLoading();
        this.$axios
          .post(API.COST_ADJUST_CONFIM, baseData)
          .then((res) => {
            loading.endLoading();
            if (res.data.code == 0) {
              this.getDetail(this.baseData.id);
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: res.data.msg,
              });
            }
          })
          .catch(() => loading.endLoading());
      },
      // 撤回
      async doWithdraw() {
        const baseData = {
          id: this.baseData.id,
        };
        loading.startLoading();
        this.$axios
          .post(API.COST_ADJUST_WITHDRAW, baseData)
          .then((res) => {
            loading.endLoading();
            if (res.data.code == 0) {
              this.goBack();
              // this.getDetail(this.baseData.id)
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: res.data.msg,
              });
            }
          })
          .catch(() => loading.endLoading());
      },
      closeDialog() {
        this.dialogVisible = false;
        // this.postDate = null;
      },
      selectTrue() {
        const accrued = {
          id: this.baseData.id,
          reverseReason: this.reverseData.reverseReason, //冲销原因
          reversePostDate: this.reverseData.reversePostDate, //冲销日期
        };
        this.loading.startLoading();
        this.$axios.post(API.COST_ADJUST_REVERSE, accrued).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.closeDialog();
            this.getDetail(this.baseData.id);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 返回
      goBack() {
        let pathList = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: {
              keepAlive: true,
              title: '成本调整单编辑',
            },
          },
          toPath: {
            path: '/wareHouse/costAdjustOrderList',
            name: 'costAdjustOrderList',
            meta: {
              keepAlive: true,
              title: '成本调整单列表',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
    },
  };
</script>
